<template>
  <div class="data-table">
    <div class="table-top">
      <span class="title">{{ optionDataTable[activeType].title }}</span>
      <span class="msg">{{ optionDataTable[activeType].msg }}</span>
    </div>
    <avue-crud ref="crud" :option="option" :table-loading="loading" :data="data" :page.sync="page" @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" @current-change="currentChange"
      @size-change="sizeChange" @on-load="onLoad">
      <template slot-scope="{row}" slot="userName">
        <div class="tag-box">
          <span class="content">{{ row.userName }}</span>
          <matrix-tag v-if="row.userType == '1'" color="#67C23A" text="调度中心"></matrix-tag>
          <matrix-tag v-else-if="row.userType == '2'" color="#854D0E" text="巡检工程师"></matrix-tag>
        </div>
      </template>
      <template slot-scope="{row}" slot="percentage">
        <el-progress :text-inside="true" :stroke-width="26" :percentage="row.percentage"></el-progress>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import { optionAll } from "./DataTable";
import matrixTag from '@/components/matrix/matrix-tag'
import { getList } from "../api";

export default {
  inject: ['parentThat'],
  data () {
    return {
      optionDataTable: optionAll,
      data: [
        // {
        //   userName: '张明远',
        //   userType: '1',
        //   team: '设备维护一组',
        //   positionType: '维修工程师',
        //   date: '2024-01-15',
        //   workHours: 8.5,
        //   taskType: '设备保养',
        //   taskName: '输送系统日常维护',
        //   percentage: 70,
        // },
      ],
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      loading: false,
      option: {
        height: '300',// 表格高度
        menu: false,
        addBtn: false,
        column: optionAll.workHourAnalysis.column
      },
    }
  },
  components: {
    matrixTag
  },
  props: {
    activeType: {
      default: ''
    }
  },
  created () {
    this.initOption()
  },

  methods: {
    // 切换tab页面 重新匹配列表配置和查询接口
    initOption () {
      this.page = { size: 10, page: 1, total: 0 }
      const { column } = optionAll[this.activeType]
      this.$set(this.option, 'column', column)
    },
    currentChange (page) {
      this.page.page = page;
    },
    sizeChange (size) {
      this.page.size = size;
    },
    onLoad (pages) {
      const { apiKey } = optionAll[this.activeType]
      this.loading = true;
      const { queryForm } = this.parentThat
      const { page, size } = pages
      getList(
        { page, size, ...queryForm }, apiKey
      ).then((res) => {
        const data = res.data.data;
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
      });
    },
  }
}
</script>

<style scoped lang="scss">
.data-table {
  margin-top: 20px;
}
::v-deep .avue-crud__search {
  display: none !important;
}
::v-deep .avue-crud__menu {
  display: none;
}
.table-top {
  height: 80px;
  line-height: 80px;
  padding-left: 10px;
  .title {
    font-size: 20px;
    font-weight: 800;
  }
  .msg {
    margin-left: 120px;
    color: #9ca3af;
  }
}
.tag-box {
  display: flex;
  justify-content: center;
  align-items: center;
  vertical-align: top;

  ::v-deep .text {
    // margin-left: 2px;
    height: 26px;
    display: inline-block;
    vertical-align: top;
  }
  .content {
    display: inline-block;
  }
}
</style>